import { debounce } from "debounce";
import Vue from "vue";

export const paginatorMixin = () =>
  Vue.extend({
    props: {
      getter: Function,
      itemsPerPage: {
        type: Number,
        default: 5,
        required: false,
      },
      headers: {
        type: Array,
        required: true,
      },
      topPagination: Boolean,
    },
    data() {
      return {
        data: {
          count: 0,
          results: [],
        },
        loading: false,
        pendingRequest: null,
        lastParams: {},
        lastFilter: {},
        pageCount: 1,
        defaultItemsPerPage: 5,
        options: {
          itemsPerPage: 10 || this.itemsPerPage,
          page: 1,
        },
      };
    },
    computed: {
      computedHeaders() {
        return this.headers.filter((header) => !header.notShow);
      },
    },
    watch: {
      options: {
        handler(value) {
          this.loading = true;
          this._debounce(value, this);
        },
        deep: true,
      },
    },
    methods: {
      _debounce: debounce(function (value, vm) {
        vm.getData({
          ...vm.lastParams,
          limit: value.itemsPerPage,
          offset: value.itemsPerPage * (value.page - 1),
        });
      }, 1000),
      async getData(params) {
        try {
          this.loading = true;
          const request = this.getter(params);
          this.pendingRequest = request;
          const response = await request;
          this.lastParams = response.config.params || {};
          // eslint-disable-next-line no-unused-vars
          const { _limit, _offset, ...lastFilter } = {
            ...response.config.params,
          };
          this.lastFilter = lastFilter;
          this.data = response.data;
        } finally {
          this.pendingRequest = null;
          this.loading = false;
        }
      },
      async findAll() {
        while (this.data.results.length < this.data.count) {
          const params = {
            offset: this.data.results.length,
          };
          await this.getData(params);
        }
      },
      async newSearch(search) {
        const params = {
          search: search,
          limit: this.options.itemsPerPage,
        };
        this.getData(params);
      },
      async newFilter(params) {
        this.getData({ ...params, limit: this.options.itemsPerPage });
      },
      addItem(item) {
        this.data.results.push(item);
        this.data.count++;
      },
      editItem(item) {
        const items = this.data.results;
        const index = items.findIndex((element) => element.uuid === item.uuid);
        this.data.results.splice(index, 1, item);
      },
      removeItem(item) {
        const items = this.data.results;
        const index = items.findIndex((element) => element.uuid === item.uuid);
        this.data.results.splice(index, 1);
      },
      refresh() {
        this.getData(this.lastParams);
      },
    },
    created() {
      if (this.itemsPerPage) {
        this.defaultItemsPerPage = this.itemsPerPage;
      }
    },
  });
